module.exports = __webpack_public_path__ + "assets/img/printer-light.d18324aa.svg";